module.exports = __webpack_public_path__ + "4f14502a988693ebab2ea6a25f92f1ec.svg";